import { createSlice } from '@reduxjs/toolkit';
import { fetchManageColumnsThunk } from './fetchManageColumnsThunk';
import { QueryState } from 'common/enums';
import { FetchManageColumnsEmptyState, IManageColumnsState } from './fetchManageColumnsState';

const initialState: IManageColumnsState = FetchManageColumnsEmptyState;

export const fetchManageColumns = createSlice({
  name: 'fetchManageColumns',
  initialState,
  reducers: {
    resetFetchManageColumns: () => {
      return initialState;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageColumnsThunk.pending, (state) => {
        state.state = QueryState.AWAIT;
      })
      .addCase(fetchManageColumnsThunk.fulfilled, (state, action) => {
        state.state = QueryState.READY;
        state.manageColumns = action.payload;
      })
      .addCase(fetchManageColumnsThunk.rejected, (state, action) => {
        state.state = QueryState.FAIL;
        state.error = action.error.message || 'Something went wrong!';
      });
  }
});

export const { resetFetchManageColumns } = fetchManageColumns.actions;
export default fetchManageColumns.reducer;
